import options from './options.json';
import validationMessages from './ValidationMessages.json';

export default { constants: { ...options, ...validationMessages } };
